import { render } from "./ResultReinsurance.vue?vue&type=template&id=32202cd3&scoped=true"
import script from "./ResultReinsurance.vue?vue&type=script&lang=js"
export * from "./ResultReinsurance.vue?vue&type=script&lang=js"

import "./ResultReinsurance.vue?vue&type=style&index=0&id=32202cd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32202cd3"]])

export default __exports__